import { HttpInterceptorFn } from '@angular/common/http';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // Pass credentials (cookies) with HTTP requests automatically
  const authReq = req.clone({
    withCredentials: true
  });
  return next(authReq);
};
